/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: ylq
 * @Last Modified time: 2023-05-18 19:30:09
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');

const DATAANALYSIS = [
  {
    path: '/data-analysis',
    name: 'data-analysis',
    component: DEFAULT_LAYOUT,
    redirect: { name: 'data-leads-analysis' },
    meta: {
      title: '数据分析',
      requiresAuth: true,
      hideChildrenInMenu: true,
      roles: 'dataAnalysis',
      icon: 'icon-computer'
      // order: 9
    },
    children: [
      {
        path: 'leads',
        name: 'data-leads-analysis',
        component: () => import('@/layout/pageTabs.vue'),
        redirect: { name: 'data-leads-analysis-index' },
        meta: {
          requiresAuth: true,
          // roles: 'dataAnalysis:dataAnalysis',
          roles: 'dataAnalysis',
          hideChildrenInMenu: true,
          hasTabs: true, // 页面是否是tabs展示
          tabsFixed: 59,
          title: '线索分析'
        },
        children: [
          {
            path: 'analysis',
            name: 'data-leads-analysis-index',
            component: () => import('@/views/data-analysis/leads-analysis/leads-analysis.vue'),
            meta: {
              requiresAuth: true,
              // roles: 'dataAnalysis:dataAnalysis',
              roles: 'dataAnalysis',
              title: '线索分析'
            }
          },
          {
            path: 'portrait',
            name: 'data-leads-portrait-index',
            component: () => import('@/views/data-analysis/leads-portrait/leads-portrait.vue'),
            meta: {
              requiresAuth: true,
              // roles: 'dataAnalysis:dataAnalysis',
              roles: 'dataAnalysis',
              title: '客户画像'
            }
          },
          {
            path: 'top',
            name: 'data-analysis-leads-index',
            component: () => import('@/views/data-analysis/leads-top/leads-top.vue'),
            meta: {
              requiresAuth: true,
              // roles: 'dataAnalysis:dataAnalysis',
              roles: 'dataAnalysis',
              title: '成员榜单'
            }
          },
          {
            path: 'dashboard',
            name: 'data-analysis-leads-dashboard',
            component: () => import('@/views/data-analysis/leads-dashboard/leads-dashboard.vue'),
            meta: {
              requiresAuth: true,
              // roles: 'dataAnalysis:dashboardAnalysis',
              roles: 'dataAnalysis',
              title: '仪表盘分析'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/bi-cockpit',
    name: 'bi-cockpit',
    component: DEFAULT_LAYOUT,
    redirect: { name: 'cockpit' },
    meta: {
      title: '驾驶舱',
      requiresAuth: true,
      hideChildrenInMenu: true,
      roles: 'dashboard'
      // subTitle: 'beta'
    },
    children: [
      {
        path: '/cockpit',
        name: 'cockpit',
        component: () => import('@/views/bi/cockpit/cockpit.vue'),
        meta: {
          title: '驾驶舱',
          requiresAuth: true,
          // hideInMenu: true,
          roles: 'dashboard:view'
        }
      },
      {
        path: '/bi-full',
        name: 'bi-full',
        redirect: { name: 'cockpit' },
        component: () => import('@/views/bi/cockpit/cockpit.vue'),
        meta: {
          title: '驾驶舱',
          requiresAuth: true,
          roles: 'dashboard:view'
        }
      },
      {
        path: 'bi',
        name: 'bi',
        component: () => import('@/views/bi/bi.vue'),
        meta: {
          title: '测试',
          requiresAuth: true,
          hideInMenu: true,
          roles: 'dashboard'
        }
      }
    ]
  },
  {
    path: '/bi-chart',
    name: 'bi-chart',
    component: DEFAULT_LAYOUT,
    redirect: { name: 'chart' },
    meta: {
      title: '图表库',
      requiresAuth: true,
      hideChildrenInMenu: true,
      roles: 'chart'
      // subTitle: 'beta'
    },
    children: [
      {
        path: '/chart',
        name: 'chart',
        // component: () => import('@/views/contract-dashboard/contract-dashboard.vue'),
        component: () => import('@/views/bi/chart/chart.vue'),
        meta: {
          title: '图表库',
          requiresAuth: true,
          // hideInMenu: true,
          roles: 'chart:view'
        }
      }
    ]
  },
  {
    path: '/contract-dashboard',
    name: 'contract-dashboard',
    component: DEFAULT_LAYOUT,
    redirect: { name: 'contract-dashboard-index' },
    meta: {
      title: '合同数据看板',
      requiresAuth: true,
      hideChildrenInMenu: true,
      roles: 'dataPlatformBoard'
      // subTitle: 'beta'
    },
    children: [
      {
        path: '',
        name: 'contract-dashboard-index',
        component: () => import('@/views/contract-dashboard/contract-dashboard.vue'),
        meta: {
          title: '合同数据看板',
          requiresAuth: true,
          // hideInMenu: true,
          roles: 'dataPlatformBoard'
        }
      }
    ]
  }
];

export default DATAANALYSIS;
